@if (oddsPreferenceConfig$ | async; as oddsPreferenceConfig) {
    <div class="odd-changes__container">
        <div class="odd-changes__header">
            <div class="h5-v2 odd-changes__header-title">{{ oddsPreferenceConfig.oddsPreferencePopupTitle }}</div>

            <div
                class="odd-changes__tooltip theme-info"
                arrowPosition="middle"
                [dsTooltipTriggerFor]="tooltipTemplate"
                [autoOpen]="false"
                [tooltipToggle]="false"
                [closeOnScroll]="false"
                [hasBackdrop]="true"
                (click)="openTooltip()">
                <vn-icon name="theme-info" size="12" />
            </div>
        </div>

        <div class="odd-changes__body">
            <div class="txt-sm-v2 text-left odd-changes__description">{{ oddsPreferenceConfig.description }}</div>
            <div class="odd-changes__options">
                <form>
                    <ds-radio-group size="large" class="odd-changes__radio-group" [(value)]="oddSelection">
                        @for (option of oddsOptions; track option) {
                            <ds-list-item
                                class="odd-changes__option-wrapper bg-white"
                                [showCenterSlot]="false"
                                [title]="option.text"
                                [subtitle]="option.subtext ?? ''"
                                [class.selected]="oddSelection === option.id">
                                <ng-container slot="start">
                                    <div class="odd-changes__options-label text-left">
                                        <div class="txt-lg-v2 txt-color-100">{{ option.text }}</div>
                                        @if (option.subtext) {
                                            <div class="txt-xs-v2 odd-changes__option-subtext">{{ option.subtext }}</div>
                                        }
                                    </div>
                                </ng-container>

                                <ng-container slot="end">
                                    <ds-radio-button name="odd-change-selection" [value]="option.id" [checked]="oddSelection === option.id" />
                                </ng-container>
                            </ds-list-item>
                        }
                    </ds-radio-group>
                </form>
            </div>

            <button
                ds-button
                kind="primary"
                variant="filled"
                size="large"
                class="odd-changes__cta-btn"
                [disabled]="!oddSelection"
                (click)="saveOddPreference()">
                {{ oddsPreferenceConfig.saveButton }}
            </button>

            <div class="txt-xs-v2 odd-changes__helper-text">{{ oddsPreferenceConfig.helperText }}</div>
        </div>
    </div>

    <ng-template #tooltipTemplate>
        <ds-tooltip-content class="odd-changes__info-tooltip">
            <span slot="close" (click)="closeTooltip()">
                <vn-icon name="theme-close-small" size="12" />
            </span>

            <div slot="description">{{ oddsPreferenceConfig.tooltipText }}</div>
        </ds-tooltip-content>
    </ng-template>
}
